/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
// MRT
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";
//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";
//import translation function for language translation
import { useTranslation } from "react-i18next";
import { assetImages } from "constants";

const FIELD_TO_PARAM = {
  title: "title",
  projectname: "projectname",
  taskstartdate: "taskstartdate",
  taskenddate: "taskenddate",
  hours: "hours",
  loggedhours: "loggedhours",
  taskpriority: "taskpriority",
  tagstring: "tagstring",
  taskstatus: "taskstatus",
};

const TaskList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t } = useTranslation(); //for translation
  const {
    reloadTaskList,
    setreloadTaskList,
    seteditTaskId,
    filterTaskDateRange,
    filterTaskTitle,
    filterTaskProjects,
    filterTaskUsers,
    filterTaskStatus,
    filterTaskPriorities,
    filterTaskLabels,
    screenHeight,
  } = useContext(GlobalProvider);
  const [TaskList, setTaskList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return TaskList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : TaskList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Task.xlsx");
  };

  /* function to get all label data */
  const getAllTaskList = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_TASKS +
        `?token=${token}&userrolestring=${userInfo.role.name}`;
      requestUrl +=
        filterTaskDateRange != "" ? `&filterdates=${filterTaskDateRange}` : "";
      if (filterTaskTitle != "") {
        requestUrl = requestUrl + `&filtertitle=${filterTaskTitle}`;
      }
      if (filterTaskLabels.length > 0) {
        requestUrl = requestUrl + `&filtertags=${filterTaskLabels}`;
      }
      if (filterTaskProjects.length > 0) {
        requestUrl = requestUrl + `&filterprojects=${filterTaskProjects}`;
      }
      if (filterTaskUsers.length > 0) {
        requestUrl = requestUrl + `&filterusers=${filterTaskUsers}`;
      }
      if (filterTaskStatus.length > 0) {
        requestUrl = requestUrl + `&filtercompletestatus=${filterTaskStatus}`;
      }
      if (filterTaskPriorities.length > 0) {
        requestUrl = requestUrl + `&filterpriorities=${filterTaskPriorities}`;
      }
      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });
      console.log("task list url =====>>>", requestUrl);
      const response = await getData(requestUrl);
      if (response.data) {
        setTaskList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <span>{dataItem.title}</span>
        <Link
          to="#add_task"
          data-bs-toggle="offcanvas"
          onClick={() => {
            seteditTaskId(dataItem._id);
          }}
          className="ml-auto edit_icon"
        >
          <span className="d-block material-symbols-outlined icon-md">
            edit
          </span>
        </Link>
        {/* <div className="dropdown cell-dropdown ms-auto mt-2">
            <button
              className="dropdown-toggle bg-transparent p-0 border-0"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-block material-symbols-outlined icon-md">
                more_vert
              </span>
            </button>
            <ul className="dropdown-menu border-0 shadow-lg">
              <li>
                <Link
                  className="dropdown-item"
                  to="#add_task"
                  data-bs-toggle="offcanvas"
                  onClick={() => {
                    seteditTaskId(dataItem._id);
                  }}
                >
                  Edit
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  to="#add_task_view"
                  data-bs-toggle="offcanvas"
                  onClick={() => {
                    seteditTaskId(dataItem._id);
                  }}
                >
                  View
                </Link>
              </li>
            </ul>
          </div> */}
      </div>
    );
  };
  //user html
  const userHtml = ({ dataItem }) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <p className="d-flex gap-2 align-items-center text-nowrap">
          <span className="d-block icon-user">
            <img
              src={
                dataItem.assigneduserimage == ""
                  ? assetImages.defaultUser
                  : dataItem.assigneduserimage
              }
              alt=""
            />
          </span>
          <span className="d-block">{dataItem.assignedusername}</span>
        </p>
      </div>
    );
  };
  //complete status html
  const statusHtml = ({ dataItem }) => {
    return (
      <span
        className={
          dataItem.completedpercent == "0"
            ? "text-orange"
            : dataItem.completedpercent == "3"
            ? "text-green"
            : dataItem.completedpercent == "1"
            ? "text-primary"
            : "text-secondary"
        }
      >
        {dataItem.taskstatus}
      </span>
    );
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "title",
        accessorKey: "title",
        header: t("Task Title"),
        Cell: ({ row }) => titleHtml({ dataItem: row.original }),
        size: 250,
      },
      {
        id: "projectname",
        accessorKey: "projectname",
        header: t("Project Name"),
        size: 200,
      },
      {
        id: "assignedusername",
        accessorKey: "assignedusername",
        header: t("Assigned To"),
        Cell: ({ row }) => userHtml({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "taskstartdate",
        accessorKey: "taskstartdate",
        header: t("Start Date"),
        size: 200,
      },
      {
        id: "taskenddate",
        accessorKey: "taskenddate",
        header: t("End Date"),
        size: 200,
      },
      {
        id: "hours",
        accessorKey: "hours",
        header: t("Hours"),
        size: 200,
      },
      {
        id: "loggedhours",
        accessorKey: "loggedhours",
        header: t("Logged Hours"),
        size: 200,
      },
      {
        id: "taskpriority",
        accessorKey: "taskpriority",
        header: t("Task Priority"),
        size: 200,
      },
      {
        id: "tagstring",
        accessorKey: "tagstring",
        header: t("Labels"),
        size: 200,
      },
      {
        id: "taskstatus",
        accessorKey: "taskstatus",
        header: t("Task Status"),
        Cell: ({ row }) => statusHtml({ dataItem: row.original }),
        size: 200,
      },
    ],
    [TaskList]
  );

  useEffect(() => {
    if (
      filterTaskDateRange != "" ||
      filterTaskTitle != "" ||
      filterTaskLabels.length > 0 ||
      filterTaskPriorities.length > 0 ||
      filterTaskProjects.length > 0 ||
      filterTaskStatus.length > 0 ||
      filterTaskUsers.length > 0
    ) {
      getAllTaskList();
    }
  }, [
    filterTaskDateRange,
    filterTaskTitle,
    filterTaskLabels,
    filterTaskProjects,
    filterTaskStatus,
    filterTaskUsers,
    filterTaskPriorities,
  ]);
  /* hook to reload list */
  useEffect(() => {
    if (reloadTaskList || !responseReceived) {
      getAllTaskList();
      if (reloadTaskList) {
        setreloadTaskList(false);
      }
    }
  }, [reloadTaskList, responseReceived]);
  /* hook to hit  exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllTaskList(columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, TaskList]);

  return (
    <div className="table-responsive rearrangeColumn">
      <MaterialReactTable
        columns={tableColumns}
        data={TaskList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
    </div>
  );
};
export default TaskList;
